<template>
  <div>

    <div class="box">

      <div class="flex flex-wrap items-center">
        <filtering-toggle-button :filtering="filtering" />

        <div class="flex-grow mb-1">
          <list-search v-model="searchInput" @search="get"/>
          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>

        <div class="flex">
          <button
            v-if="hasPermission('financial-transfer.export')"
            type="button"
            class="btn btn-green text-sm px-3 flex items-center mb-1"
            :disabled="!exportFile.transfer.enabled"
            @click="exportTransfers"
          >
            <i class="fas fa-spinner fa-spin mr-2" v-if="!exportFile.transfer.enabled"></i>
            <span>Export</span>
          </button>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="get">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap justify-center">
        <div
          class="w-full lg:w-2/12 pr-2 pt-4 border-r border-theme-darker"
          v-show="filtering.active"
        >
          <financial-transfer-filters
            :filters.sync="filters"
            @updated="get"
            @has-changes="filtering.hasChanges = $event"
          />
        </div>

        <div class="w-full" :class="{ 'lg:w-10/12': filtering.active}">
          <p class="text-lg text-center my-12" v-if="!hasTransfers">No data to display</p>
          <div class="overflow-x-auto" v-else>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Value</th>
                  <th>Note</th>
                  <th>Created at</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transfer, i) in transfers" :key="i">
                  <td class="font-bold">{{ transfer.id }}</td>
                  <td>
                    <span v-if="transfer.from" :class="transfer.from.type === 'cash' ? 'text-success' : 'text-info'">
                      {{ transfer.from.name }}
                      <span v-if="transfer.from.deleted_at" class="text-sm text-red-500">(deleted)</span>
                    </span>
                  </td>
                  <td>
                    <span v-if="transfer.to" :class="transfer.to.type === 'cash' ? 'text-success' : 'text-info'">
                      {{ transfer.to.name }}
                      <span v-if="transfer.to.deleted_at" class="text-sm text-red-500">(deleted)</span>
                    </span>
                  </td>
                  <td>{{ $formatMoney(transfer.value) }}</td>
                  <td>{{ transfer.note }}</td>
                  <td>{{ $moment(transfer.created_at).format(config.dateTimeFormats.display) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="w-full flex justify-center">
            <pagination-component
              class="mt-8"
              v-if="hasTransfers && pagination.totalRows / pagination.perPage > 1"
              v-model="pagination.currentPage"
              :total-rows="pagination.totalRows"
              :rows-per-page="pagination.perPage"
            />
          </div>

        </div>
      </div>

    </div>


  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const FilteringToggleButton = resolve => require(['@/components/filters/FilteringToggleButton'], resolve)
const FinancialTransferFilters = resolve => require(['@/components/filters/Filters'], resolve)
const ListSearch = resolve => require(['@/components/ListSearch'], resolve)
const PaginationComponent = resolve => require(['@/components/Pagination'], resolve)

export default {
  components: {
    FilteringToggleButton,
    FinancialTransferFilters,
    ListSearch,
    PaginationComponent,
  },
  data() {
    return {
      transfers: [],
      searchInput: '',
      query: {
        search: '',
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      },
      filtering: {
        active: false,
        hasChanges: false,
      },
      filters: {
        status: {
          key: 'status',
          name: 'Status',
          active: true,
          options: [
            {name: 'Completed', value: 'completed', class: 'btn-green'},
            {name: 'Ongoing', value: 'ongoing', class: 'btn-orange'},
          ],
          value: null,
        },
        createdAt: {
          key: 'created_at',
          name: 'Created at date',
          active: true,
          flatpickr: {
            mode: 'range',
            static: false,
          },
          value: null,
        },
      },
      exportFile: {
        transfer: {
          enabled: true,
        }
      },
    }
  },
  watch: {
    'pagination.currentPage'() {
      this.get()
    },
  },
  computed: {
    hasTransfers() {
      return Object.entries(this.transfers).length > 0
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    exportTransfers() {
      let filters = this.$getFilterValues(this.filters)
      if (filters.created_at) {
        let createdAt = this.$getRangeDates(filters.created_at, this.config)
        filters.dateFrom = createdAt.from
        filters.dateTo = createdAt.to
      }

      this.exportFile.transfer.enabled = false
      axios.get('financial-transfers/export', {
        params: {
          search: this.searchInput,
          filters,
        },
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.$downloadFile(response)
          this.exportFile.transfer.enabled = true
        })
    },
    get() {
      let filters = this.$getFilterValues(this.filters)
      if (filters.created_at) {
        let createdAt = this.$getRangeDates(filters.created_at, this.config)
        filters.dateFrom = createdAt.from
        filters.dateTo = createdAt.to
      }

      axios.get('financial-transfers', {params:{
        page: this.pagination.currentPage,
        search: this.searchInput,
        filters,
      }})
        .then(response => {
          const res = response.data
          this.pagination.perPage = res.per_page
          this.pagination.totalRows = res.total

          this.transfers = Object.assign([], res.data)

          this.query.search = this.searchInput
        })
    }
  }
}
</script>
